export default __webpack_public_path__ + "static/media/regular.52d876d2.woff";